<template>
  <div class="animated fadeIn">
    <b-card size="sm" footer-bg-variant="white" footer-border-variant="white">
      <div slot="header">
        <i class="icon-note"></i> Freezer Request Detail
      </div>

      <b-card-body>
        <div>
          <b-form id="employeeForm" validated novalidate @submit="freezerRequestForm">
          
            <div v-if="loading == false">
             
             <b-row>
                <b-col sm="3">
                  <b-form-group label-for="product_group" label="Konsumen">
                      <vue-autosuggest
                          v-model="customers.text"
                          @inputout="focusMe"
                          :suggestions="filteredOptions"
                          @input="onInputChange"
                          @selected="onSelected"
                          :input-props="{ id: 'customer', placeholder: 'Find Customer', class: 'form-control', readonly: true}"
                          :limit="20"
                      >
                          <template slot-scope="{ suggestion }">
                          <span class="my-suggestion-item"> 
                              {{ suggestion.item.text }}
                          </span>
                          </template>
                      </vue-autosuggest>
                      <div v-if="freezerRequestForm.customer_id === null" class="invalid-feedback-custom">Konsumen harus di isi.</div>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="request_type" label="Tipe Permintaan">
                    <model-select
                      id="request_type"
                      :options="listRequestType"
                      v-model="$v.freezerRequestForm.request_type.$model"
                      :isError="$v.freezerRequestForm.request_type.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                       :isDisabled="true"
                    ></model-select>
                    <div
                      v-if="freezerRequestForm.request_type === null"
                      class="invalid-feedback-custom"
                    >Tipe permintaan harus di isi.</div>
                  </b-form-group>
                </b-col>
             </b-row>

             <b-row>
                <b-col sm="6">
                  <b-form-group label-for="notes" label="Notes">
                    <b-form-textarea
                      id="notes"
                      :rows="3"
                      :max-rows="6"
                      v-model="freezerRequestForm.notes"
                    ></b-form-textarea>
                    <b-form-invalid-feedback>Notes harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
             </b-row>
              

              <div slot="footer" class="text-right">
                <b-button type="button" size="sm" variant="danger" @click="back">
                  <i class="fa fa-undo"></i> Back
                </b-button>&nbsp;
                <b-button v-if="freezerRequestForm.status === '1'" type="button" size="sm" variant="warning" @click="cancelRequest">
                  <i class="fa fa-ban"></i> Cancel
                </b-button>
              </div>
            </div>

            <div v-else>
              <loading></loading>
            </div>
          </b-form>
        </div>
      </b-card-body>
    </b-card>

     <b-card size="sm" footer-bg-variant="white" footer-border-variant="white">
      <b-tabs>
        <b-tab v-if="freezerRequestForm.request_type === '1'" title="Penempatan Asset" active>
          <asset-placement
            :customer="dataCustomer"
            :customer-asset="customerAsset"
            :list-asset-owner="listAssetOwner"
            :list-asset-status="listAssetStatus"
            :list-status-customer-asset="listStatusCustomerAsset"
            :list-employee="listEmployee"
            :child-add-button="(freezerRequestForm.status !== '1') ? false:childAddButton"
            :is-disable="isReadonly"
            :loading="loading"
            @reload="init"
          ></asset-placement>
        </b-tab>

        <b-tab v-if="freezerRequestForm.request_type === '2'" title="Penarikan Asset" active>
          <asset-return
            :customer="dataCustomer"
            :customer-asset-return="customerAssetReturn"
            :customer-asset-avail="customerAsset"
            :list-asset-status="listAssetStatus"
            :loading="loading"
            :is-disable="isReadonly"
            :child-add-button="(freezerRequestForm.status !== '1') ? false:childAddButton"
            :list-employee="listEmployee"
            @reload="init"
          ></asset-return>
        </b-tab>
      </b-tabs>
    </b-card>
    
    <b-modal
        ref="cancelModalsRef"
        id="cancelModals"
        header-border-variant="no-border text-center"
        footer-border-variant="no-border"
        footer-bg-variant="light"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        hide-footer
        size="lg"
      >
        <div slot="modal-header" class="text-center">
          <h3 class="text-center">Cancel Request</h3>
        </div>

        <div v-if="!loadingSubmit">
          <b-form id="req" validated novalidate @submit="processCancel">
            <b-row>
              <b-col sm="12">
                <b-form-group label-for="cancelled_notes" label="Notes">
                    <b-form-textarea
                      id="cancelled_notes"
                      :rows="3"
                      :max-rows="6"
                      v-model="cancelledRequestForm.cancelled_notes"
                    ></b-form-textarea>
                    <b-form-invalid-feedback>Notes harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
              </b-col>
            </b-row>


            <div class="float-right">
              <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
                <i class="fa fa-undo"></i> Back
              </b-button>&nbsp;
              <b-button
                type="submit"
                size="sm"
                variant="primary"
                :disabled="$v.cancelledRequestForm.$invalid"
              >
                <i class="fa fa-save"></i> Save
              </b-button>
            </div>
          </b-form>
        </div>

        <div v-else>
          <loading></loading>
        </div>
      </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "../../templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import { VueAutosuggest } from 'vue-autosuggest';
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect, MultiSelect } from "vue-search-select";
import assetPlacement from "../customer/tabs/AssetPlacement";
import assetPlacementAlter from "../customer/tabs/AssetPlacementAlter";
import documentCustomer from "../customer/tabs/DocumentCustomer";
import assetReturn from "../customer/tabs/AssetReturn";
import loading from "@/templates/Loading.vue";

export default {
  name: "customer",
  components: { globalTable, ModelSelect, MultiSelect, assetPlacement, documentCustomer, assetReturn,assetPlacementAlter, loading, VueAutosuggest },
  props: {
    tableDetail: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      freezerRequestForm: interfaces.freezer_request,
      cancelledRequestForm: {
        cancelled_notes: null
      },
      listRequestType: [],
      listStatus: [],
      loading: true,
      loadingSubmit: false,
      totalRows: "",
      customerAsset: [],
      listEmployee: [],
      customerAssetReturn: [],
      listAssetStatus: [],
      listAssetOwner: [],
      filteredOptions: [],
      dataCustomer: [],
      listCustomerStatus: [
        { value: "1", text: "Aktif" },
        { value: "2", text: "Non Aktif" }
      ],
      listStatusCustomerAsset: [
        { value: "1", text: "Dipakai" },
        { value: "2", text: "Dikembalikan" }
      ],
      customers: {
        text: null,
        value: null
      },
      suggestions: [
        {
          data: [],
        },
      ],
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  validations: {
    freezerRequestForm: {
      customer_id: { required },
      request_type: { required }
    },
    cancelledRequestForm: {
      cancelled_notes: { required }
    }
  },
  computed: {
    childAddButton() {
      let employee_id = localStorage.getItem("nik");
      return (['13', '9', '11'].includes(localStorage.getItem("division_id")) || localStorage.getItem("level") === "1" ||
        ['MBS22090004'].includes(employee_id)) ? true : false;
    },
    isReadonly() {
      let employee_id = localStorage.getItem("nik");
      return localStorage.getItem("level") === "1" ||
        localStorage.getItem("level") === "2" ||
        ['MBS22090004'].includes(employee_id)
        ? false
        : true;
    },
    allowEdit() {
      let employee_id = localStorage.getItem("nik");
      return (['MBS19080016', 'MBS22060005', 'MBS22090004'].includes(employee_id)) ? false: true;
    }
  },
  methods: {
    init: function(cust_id) {
      this.loading = true;
      this.getRequestDetail(cust_id);
      this.getDropdown();
      this.getDropdown2();
      this.isEdit = false;
     
    },
    focusMe: function(item){
       if (item === "" || item === undefined || item === null) {
        this.freezerRequestForm.customer_id = null;
        this.customers.value = null;
        this.customers.text = null;
        return;
      }
    },
    onInputChange(text) {
      if (text === "" || text === undefined || text === null) {
        this.freezerRequestForm.customer_id = null;
        this.customers.value = null;
        this.customers.text = null;
        return;
      } else {
        axios
          .post("web/dropdown/find-customer/", {'name':text})
          .then((response) => {
            this.dropdown_customer = response.data.data;
            this.suggestions[0].data = this.dropdown_customer;
            const filteredData = this.suggestions[0].data;
            this.filteredOptions = [
              {
                data: filteredData,
              },
            ];
          })
          .catch((error) => {})
          .finally(() => {});
      }
    },
    getRequestDetail(id) {
      this.axios
        .get("web/assets/freezer-request/detail/" + id + "/")
        .then(response => {
           this.customers = {
            value: response.data.data.customer_id,
            text: response.data.data.customer_name
           };
          this.freezerRequestForm = response.data.data;
          this.dataCustomer.id = response.data.data.customer_id;
          this.dataCustomer.request_code = response.data.data.request_code;
          this.dataCustomer.request_id = response.data.data.id;
          this.customerAsset = response.data.customer_assets;
          this.customerAssetReturn = response.data.customer_assets_return;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    processCancel: function(evt) {
      evt.preventDefault();
        if (confirm("Apakah anda ingin membatalkan tiket ini ?")) {
          this.cancelledRequestForm.id = this.freezerRequestForm.id;
          this.axios
            .put("web/assets/freezer-request/cancel-request/", this.cancelledRequestForm)
            .then(response => {
              let _detailData = response.data.data;
              this.showInfoNotification({
                title: "Cancel Request",
                message: response.data.message
              });
            })
            .catch(error => {
              this.expired(error, "Cancel Request");
            })
            .finally(() => {
              this.cancelAdd();
              let route = this.$route.path.split("/");
              this.init(route[4]);
            });
        }
    },
    cancelRequest: function() {
      this.$refs.cancelModalsRef.show();
    },
    cancelAdd: function() {
      this.$refs.cancelModalsRef.hide();
      this.cancelledRequestForm.cancelled_notes = null;
    },
    getDropdown: function() {
      this.axios
        .get("web/dropdown/dropdown-request-freezer")
        .then(response => {
          this.listRequestType = response.data.request_type;
          this.listStatus = response.data.freezer_request_status;
        })
        .catch(error => {})
        .finally(() => {});
    },
    getDropdown2() {
      this.axios
        .get("web/dropdown/dropdown-customer/")
        .then(response => {
          this.listEmployee = response.data.employee;
          this.listAssetOwner = response.data.asset_owner;
          this.listAssetStatus = response.data.asset_status;
        })
        .catch(error => {})
        .finally(() => {
          //this.loading = false;
        });
    },
    onSelected(item) {
      if (item === "" || item === undefined || item === null) {
        this.customers.value = null;
        this.customers.text = null;
        this.freezerRequestForm.customer_id = null;
        return;
      } else {
        this.freezerRequestForm.customer_id = item.item.value;
        this.customers.value = item.item.value;
        this.customers.text = item.item.text;
     }
    },
    back: function() {
      this.$router.go(-1);
    },
    editCustomer: function(evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah konsumen ini ?")) {
        let customers = this.customerForm;
        this.axios
          .put("web/customer/change-customer/", this.customerForm)
          .then(response => {
            let _detailData = response.data.data;
            this.showInfoNotification({
              title: "Ubah Konsumen Detail",
              message: response.data.message
            });
          })
          .catch(error => {
            this.expired(error, "Ubah Konsumen Detail");
          })
          .finally(() => {
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  }
};
</script>


<style>
.demo { 
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}
 
input {
  width: 260px;
  padding: 0.5rem;
}
 
.autosuggest__results > ul {
  width: 100%;
  color: rgba(30, 39, 46,1.0);
  list-style: none;
  margin: 0;
  padding: 0.5rem 0 .5rem 0;
}
.autosuggest__results > ul > li {
  margin: 0 0 0 0;
  border-radius: 5px;
  padding: 0.75rem 0 0.75rem 0.75rem;
  display: flex;
  align-items: center;
}
.autosuggest__results > ul > li:hover {
  cursor: pointer;
}
 
.autosuggest-container {
  display: flex;
  justify-content: center;
  width: 280px;
}
 
#autosuggest { width: 100%; display: block;}
.autosuggest__results-item--highlighted {
  background-color: rgba(51, 217, 178,0.2);
}
#autosuggest__input {
      outline: none;
      position: relative;
      display: block;
      font-family: monospace;
      font-size: 20px;
      border: 1px solid #616161;
      padding: 10px;
      width: 100%;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
    }
    
    #autosuggest__input.autosuggest__input-open {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
    
    .autosuggest__results-container {
      position: relative;
      width: 100%;
    }
    
    .autosuggest__results {
      font-weight: 300;
      margin: 0;
      position: absolute;
      z-index: 10000001;
      width: 100%;
      border: 1px solid #e0e0e0;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      background: white;
      padding: 0px;
      overflow: scroll;
      max-height: 200px;
    }
    
    .autosuggest__results ul {
      list-style: none;
      padding-left: 0;
      margin: 0;
    }
    
    .autosuggest__results .autosuggest__results_item {
      cursor: pointer;
      padding: 15px;
    }
    
    #autosuggest ul:nth-child(1) > .autosuggest__results_title {
      border-top: none;
    }
    
    .autosuggest__results .autosuggest__results_title {
      color: gray;
      font-size: 11px;
      margin-left: 0;
      padding: 15px 13px 5px;
      border-top: 1px solid lightgray;
    }
    
    .autosuggest__results .autosuggest__results_item:active,
    .autosuggest__results .autosuggest__results_item:hover,
    .autosuggest__results .autosuggest__results_item:focus,
    .autosuggest__results .autosuggest__results_item.autosuggest__results_item-highlighted {
      background-color: #b6adad;
    }
</style>